import { getContrast, mix } from "polished";

function readableBrandText(brand: string, surface: string, ink: string): string {
    for (let amount = 0; amount <= 1; amount += 0.05) {
        const color = mix(amount, ink, brand);
        if (getContrast(color, surface) >= 4.5) return color;
    }
    return ink;
}

/** Resolve the identity stylesheet's accent as Bloom's primary brand colour. */
export function initializeBranding(): void {
    const root = document.documentElement;
    const styles = getComputedStyle(root);
    let brand = "#4a7c59";

    for (const name of ["--accent", "--primary-base-color"]) {
        const candidate = styles.getPropertyValue(name).trim();
        if (!candidate) continue;
        try {
            // Also validates the configured colour before using it in the palette.
            getContrast(candidate, "#ffffff");
            brand = candidate;
            break;
        } catch {
            // Invalid or missing identity colours retain Bloom's default.
        }
    }

    root.style.setProperty("--identity-brand", brand);
    root.style.setProperty("--identity-on-brand", getContrast(brand, "#ffffff") >= getContrast(brand, "#1a1714") ? "#ffffff" : "#1a1714");
    root.style.setProperty("--identity-brand-ink", readableBrandText(brand, mix(0.07, brand, "#faf9f6"), "#1a1714"));
    root.style.setProperty("--identity-brand-ink-dark", readableBrandText(brand, mix(0.16, brand, "#1a1714"), "#ffffff"));
}
